/**
 * @owner @Appboy/core-objects
 */
import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsObjectRelationshipTypeFields =
  "/data_objects/object_relationship_types/:rel_type_id/fields" as const;

/**
 * Invalidated after create mutations on this resource. Includes the relationship type schema GETs,
 * since a new field changes the schema they return.
 */
export const customObjectsObjectRelationshipTypeFieldsCacheKeys: AllRouteEndpoints[] = [
  customObjectsObjectRelationshipTypeFields,
  "/data_objects/object_relationship_type_schema",
  "/data_objects/user_relationship_type_schema",
];
